import Bugsnag, { NotifiableError } from '@bugsnag/js'
import { AssignResponse, LogExposureResponse } from '@goatapp/protos-gen-node/darwin/v1/darwin_pb'
import axios from 'axios'
import { EXPERIMENT_NAME } from 'experiments/constants/Experiments'
import { refreshCrsf } from 'shared/utils/requestService'

async function getHeaders() {
  return {
    'X-CSRF-TOKEN': await refreshCrsf(),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
}

/**
 * Calls endpoint to assign a group to the current user for the specified Darwin experiment
 *
 * @param experimentName Name of Darwin experiment
 */
export async function clientAssign(experimentName: EXPERIMENT_NAME) {
  try {
    const url = `/darwin/assign?experimentName=${experimentName}`
    const response = await axios.get<AssignResponse.AsObject>(url, {
      timeout: 4000,
      headers: await getHeaders(),
    })

    return response.data.group
  } catch (error) {
    Bugsnag.notify(error as NotifiableError, (event) => {
      event.context = 'Darwin Service clientAssign'
    })
    return Promise.reject({ reason: 'Failed to assign group' })
  }
}

/**
 * Calls endpoint to log the exposure of the current user to the specified Darwin experiment
 *
 * @param experimentName Name of Darwin experiment
 * @param metaData Optional metadata to append to the log event
 */
export async function clientLogExperiment(
  experimentName: string,
  metaData: Record<string, unknown>,
) {
  try {
    const url = `/darwin/log_exposure?experimentName=${experimentName}`
    const logTimestamp = new Date()
    const response = await axios.post<LogExposureResponse.AsObject>(
      url,
      {
        logTimestamp,
        metaData,
      },
      {
        timeout: 4000,
        headers: await getHeaders(),
      },
    )

    return response.data.group
  } catch (error) {
    Bugsnag.notify(error as NotifiableError, (event) => {
      event.context = 'Darwin Service clientLogExperiment'
    })
    return Promise.reject({ reason: 'Failed to log experiment exposure' })
  }
}
